@if (type === 'button') {
  <button
    class="btn dropdown-toggle btn-primary border btn-small"
    type="button"
    id="dropdownMenuButton"
    data-bs-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false">
    {{label | translate}}
  </button>
}
@if (type === 'icon') {
  <a
    class="btn icon-burger-mini" href="#" id="dropdownMenuLink" data-bs-toggle="dropdown">
  </a>
}

<div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
  <ng-content></ng-content>
</div>
